import React from 'react';
import { useTranslation } from 'react-i18next';
import layoutStyles from '../../styles/layout.module.css';
import styles from './Hero.module.css';

const Hero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.colorWrapper}>
      <main className={`${layoutStyles.container} ${styles.main}`}>
        <div className={styles.content}>
          <h1>{t('hero.title')}</h1>
          <p className={styles.subtitle}>
            {t('hero.description')}
          </p>
          <p className={styles.subtitle}>
            {t('hero.innovation')}
          </p>
          <p className={styles.sectorTitle}>
            {t('hero.sectorsIntro')}
          </p>
          <ul className={styles.sectorList}>
            <li>{t('hero.sectors.biotech')}</li>
            <li>{t('hero.sectors.mentalHealth')}</li>
            <li>{t('hero.sectors.music')}</li>
            <li>{t('hero.sectors.transport')}</li>
            <li>{t('hero.sectors.realEstate')}</li>
            <li>{t('hero.sectors.agropharmaceutical')}</li>
            <li>{t('hero.sectors.general')}</li>
          </ul>
          <p className={styles.closing}>
            {t('hero.closing')}
          </p>
        </div>
        <div className={styles.heroImage}>
          <img src="/ideas-progress-vision-inspiration-design-concept.jpg" alt="Marketing illustration" />
        </div>
      </main>
    </div>
  );
};

export default Hero;
